import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ListService<MODEL = any> {
  listRefreshed = new Subject<boolean | undefined>(); // boolean = clearCache
}
